import common from './common.json';
import navigation from './navigation.json';
import pages from './pages.json';
import auth from './auth.json';
import pinyin from './pinyin.json';
import chengyu from './chengyu.json';

export default {
  common,
  navigation,
  pages,
  auth,
  pinyin,
  chengyu,
};
